import React from 'react';

import {LoadingSpinner} from '@albert-io/atomic';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import FreeResponseQuestionGuide from './FreeResponseQuestionGuide/V2/FreeResponseQuestionGuide.react';

/**
 * Feature-flag wrapper for the /free-response guide listing route.
 * Passes `usePracticeViewLinks` prop to the legacy guide when flag is ON,
 * which changes link targets from /free-response/:set to /learn/:subject/:guideLevel/:set.
 */
const FRQGuideRouter = (props) => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('ai_graded_frq');

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return <FreeResponseQuestionGuide {...props} usePracticeViewLinks={isFeatureEnabled} />;
};

export default FRQGuideRouter;
